import $ from 'jquery'

function getCommunityId () {
  return $('#community-id').attr('data-data')
}

function getDeviceType () {
  return $('#device-type').attr('data-data')
}

function getCurrentPage () {
  const pageClasses = $('body')[0].className.split(/\s+/)
  const pages = {
    'twig_site-index': 'homepage',
    'category-page': 'category',
    'twig_page-topic': 'topic',
    'twig_default-member-profile': 'profile',
    'twig_topic-new': 'create',
    'forum--search': 'search'
  }

  const currentPageClass = Object.keys(pages).find(pageItem => pageClasses.indexOf(pageItem) !== -1)
  return pages[currentPageClass]
}

function getGATokens () {
  return new Promise((resolve, reject) => {
    let trackersList = []

    if (!window.ga) {
      resolve([])
    } else {
      var timing = setTimeout(function () {
        reject(new Error('GA timeout'))
      }, 2000)

      window.ga(function () {
        const trackers = window.ga.getAll()
        trackersList = trackers.map(tracker => tracker.get('name'))
        clearTimeout(timing)
        resolve(trackersList)
      })
    }
  })
}

export default {
  getCommunityId: getCommunityId, // For test
  getDeviceType: getDeviceType, // For test
  communityId: getCommunityId(),
  deviceType: getDeviceType(),
  currentPage: getCurrentPage(),
  getGATokens: getGATokens
}
